import { FC, ReactElement } from 'react'

import './DayHeader.scss'

interface HeaderProps {
    header: string
    className?: string
}

export const DayHeader: FC<HeaderProps> = ({
    header,
    className = '',
}): ReactElement => (
    <div className={`day-header ${className}`}>
        {header}
    </div>
)
